import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ImportNovo,
  LoteImport,
  Pagina,
  ResultadoAplicar,
  TemplateImport,
  TipoImport,
} from '@pcp/contracts';
import { api } from './client';

export const importKeys = {
  list: (tipo: TipoImport | '') => ['imports', tipo] as const,
};

export function useTemplateImport() {
  return useMutation({
    mutationFn: (tipo: TipoImport) => api<TemplateImport>(`/imports/templates/${tipo}`),
  });
}

/** Histórico de importações (mais recentes primeiro). */
export function useImports(tipo: TipoImport | '') {
  return useQuery({
    queryKey: importKeys.list(tipo),
    queryFn: ({ signal }) =>
      api<Pagina<LoteImport>>('/imports', { query: { 'tipo-import': tipo || undefined, page: 1 }, signal }),
  });
}

export function useCriarImport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ImportNovo) => api<LoteImport>('/imports', { method: 'POST', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['imports'] }),
  });
}

export function useAplicarImport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (nrImport: number) =>
      api<ResultadoAplicar>(`/imports/${nrImport}/aplicar`, { method: 'POST' }),
    // aplicar altera cadastros e o status das linhas
    onSuccess: () =>
      Promise.all(
        ['imports', 'capacidade', 'calendario', 'planos'].map((k) => qc.invalidateQueries({ queryKey: [k] })),
      ),
  });
}
